/*
 * App action types *
 */
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SELECT_ANALYZE_TYPE = "SELECT_ANALYZE_TYPE";
export const SELECT_ATTRIBUTE = "SELECT_ATTRIBUTE";
export const SELECT_REPORT_TYPE = "SELECT_REPORT_TYPE";
export const CLICK_STORE = "CLICK_STORE";
export const SELECT_STORE = "SELECT_STORE";
export const CLICK_ATTRIBUTE = "CLICK_ATTRIBUTE";

/*
 * Data action types*
 */
export const FETCH_GEO_DISTRICTS = "FETCH_GEO_DISTRICTS";
export const FETCH_DATA_DISTRICTS = "FETCH_DATA_DISTRICTS";
export const FETCH_DATA_STORES = "FETCH_DATA_STORES";
export const FETCH_DATA_COUNTRY = "FETCH_DATA_COUNTRY";
export const FETCH_DAILY_PATTERNS = "FETCH_DAILY_PATTERNS";
export const FETCH_RECENT_TRENDS = "FETCH_RECENT_TRENDS";
